import { render } from "./RevenueGrowthChart.vue?vue&type=template&id=27d395e0"
import script from "./RevenueGrowthChart.vue?vue&type=script&lang=js"
export * from "./RevenueGrowthChart.vue?vue&type=script&lang=js"

import "./RevenueGrowthChart.vue?vue&type=style&index=0&id=27d395e0&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__